module.exports = __webpack_public_path__ + "img/yumi.02bec2a7.png";